module.exports = __webpack_public_path__ + "img/bear.621c280b.png";